export var roundTo = function (value, roundTo) {
    return Math.round(value / roundTo) * roundTo;
};
